import { get, patch, post, destroy } from './httpClient'

export const getLockOrderSettings = (query) => get('/lock-order-settings', query)
export const updateLockOrderSettings = (body) => post('/lock-order-settings/update', body)
export const deleteLockOrderSettings = (body) => destroy('/lock-order-settings/delete', body)